import { HIGHWAY, MARKET, RING_ROAD, TOWN, UNIVERSITY } from './streetscapes';
import type { Route } from './types';

/** DRAFT: best guess via Mallam, Achimota and Tetteh Quarshie, then up the Legon road. Please correct. */
export const KASOA_MADINA: Route = {
  id: 'kasoa-madina',
  name: 'Kasoa ⇄ Madina',
  from: 'Kasoa',
  to: 'Madina',
  length: 5800,
  legs: [
    { id: 'kasoa', name: 'Kasoa', subtitle: 'Kasoa Market to Old Barrier', start: 0, end: 900, traffic: 1.2, streetscape: MARKET },
    { id: 'weija', name: 'Weija', subtitle: 'Winneba Road', start: 900, end: 1900, traffic: 1.0, streetscape: HIGHWAY },
    { id: 'achimota', name: 'Lapaz & Achimota', subtitle: 'George Bush Highway', start: 1900, end: 3300, traffic: 1.1, streetscape: TOWN },
    { id: 'shiashie', name: 'Tetteh Quarshie', subtitle: 'Shiashie to Okponglo', start: 3300, end: 4400, traffic: 1.0, streetscape: RING_ROAD },
    { id: 'legon', name: 'Legon', subtitle: 'University of Ghana to Madina', start: 4400, end: 5800, traffic: 0.9, streetscape: UNIVERSITY },
  ],
  stops: [
    { id: 'kasoa', name: 'Kasoa', at: 160, crowd: [6, 10] },
    { id: 'old-barrier', name: 'Old Barrier', at: 620, crowd: [2, 5] },
    { id: 'weija', name: 'Weija Junction', at: 1100, crowd: [3, 6] },
    { id: 'mallam', name: 'Mallam Junction', at: 1580, crowd: [4, 7] },
    { id: 'lapaz', name: 'Lapaz', at: 2080, crowd: [4, 7] },
    { id: 'achimota', name: 'Achimota', at: 2560, crowd: [3, 6] },
    { id: 'tetteh-quarshie', name: 'Tetteh Quarshie', at: 3040, crowd: [3, 6] },
    { id: 'shiashie', name: 'Shiashie', at: 3520, crowd: [2, 5] },
    { id: 'okponglo', name: 'Okponglo', at: 4000, crowd: [2, 5] },
    { id: 'legon', name: 'Legon', at: 4480, crowd: [4, 8] },
    { id: 'upsa', name: 'UPSA', at: 4960, crowd: [3, 6] },
    { id: 'madina', name: 'Madina', at: 5560, crowd: [6, 10] },
  ],
  junctions: [
    { id: 'kasoa', name: 'Kasoa junction', at: 380 },
    { id: 'weija', name: 'Weija junction', at: 860 },
    { id: 'lapaz', name: 'Lapaz junction', at: 1820 },
    { id: 'achimota', name: 'Achimota junction', at: 2300 },
    { id: 'tetteh-quarshie', name: 'Tetteh Quarshie', at: 2780 },
    { id: 'okponglo', name: 'Okponglo junction', at: 3780 },
    { id: 'legon', name: 'Legon junction', at: 4740 },
    { id: 'madina-zongo', name: 'Madina Zongo junction', at: 5260 },
  ],
  stations: [
    { id: 'ohene-fuel', name: 'Ohene Fuel', at: 980 },
    { id: 'adinkra-oil', name: 'Adinkra Oil', at: 2900 },
    { id: 'achimota-oil', name: 'Achimota Oil', at: 5080 },
  ],
};
